import { BaseFactory } from '../base.factory';
import { AppInfoModel } from '../../model/app-info-model';

class Factory extends BaseFactory {

    constructor() {
        // super( true, true, process.env.SUITE_URL);
        super(true, true, `${process.env.VUE_APP_SUITE_URL}`);
    }

    public getAppInfo = async (): Promise<AppInfoModel> => {
        try {
            const result = await this.get('/app', undefined) as AppInfoModel;
            return result;
        } catch (error) {
            throw error;
        }
    }
}

export const AppInfoFactory = new Factory();
